import { TTableLink, TRow } from "../../listing-table.types";

import { ExternalLink } from "./external-link.component";

export const renderExternalLink = (row: TRow, link?: TTableLink) => {
  if (!link) {
    return null;
  }

  return <ExternalLink link={link(row)} />;
};
